import { CSSProperties, FunctionComponent, HTMLAttributes } from 'react';
import { cssVars as palette } from '../../theme/cssVars';

type CircularColor = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';

type CircularProgressUIProps = {
  size?: number | string,
  thickness?: number,
  color?: CircularColor,
} & HTMLAttributes<HTMLSpanElement>;

const colorValue: Record<CircularColor, string> = {
  inherit: 'currentColor',
  primary: palette.primary,
  secondary: palette.secondary,
  error: palette.error,
  info: palette.info,
  success: palette.success,
  warning: palette.warning,
};

// Indeterminate spinner. MUI renders a rotating SVG arc; this uses an equivalent
// CSS ring (transparent top border) rotated via Tailwind's `animate-spin`.
// Base is inline so call-site `style` (margins) merges/overrides.
const CircularProgressUI: FunctionComponent<CircularProgressUIProps> = ({
  size = 40,
  thickness = 4,
  color = 'primary',
  className = '',
  style,
  ...rest
}) => {
  const dim = typeof size === 'number' ? `${size}px` : size;
  const baseStyle: CSSProperties = {
    display: 'inline-block',
    boxSizing: 'border-box',
    width: dim,
    height: dim,
    border: `${thickness}px solid ${colorValue[color]}`,
    borderTopColor: 'transparent',
    borderRadius: '50%',
    ...style,
  };
  return <span role="progressbar" className={`animate-spin ${className}`} style={baseStyle} {...rest} />;
};

export default CircularProgressUI;
